import React from 'react';
import { motion } from 'framer-motion';
import '../../../styles/Animatedstepindicator.css';
import IconAnimate from '../../../assets/svg/IconAnimate';
import IconSalary from '../../../assets/svg/IconSalary';
import UserIcon from '../../../assets/svg/IconUser';
import IconDoller from '../../../assets/svg/IconDoller';
import SettingUserIcon from '../../../assets/svg/SettingUserIcon';
import SearchIcon from '../../../assets/svg/SerachIcon';
import Usericon from '../../../assets/svg/UserIcon';


const AnimatedStepIndicator = () => {
    // Floating icons data - distributed across the screen
    const floatingIcons = [
        { icon: <IconAnimate/>, delay: 0, position: { top: '5%', left: '5%' }, yRange: 30 },
        { icon: <IconSalary/>, delay: 0.5, position: { top: '15%', left: '12%' }, yRange: 40 },
        { icon: <UserIcon/>, delay: 1, position: { top: '30%', left: '8%' }, yRange: 35 },
        { icon: <IconDoller/>, delay: 1.5, position: { top: '10%', right: '8%' }, yRange: 45 },
        { icon: <SettingUserIcon/>, delay: 2, position: { top: '5%', right: '15%' }, yRange: 50 },
        { icon: <SearchIcon/>, delay: 2.5, position: { top: '25%', right: '5%' }, yRange: 40 },
        { icon: <Usericon/>, delay: 3, position: { top: '40%', left: '3%' }, yRange: 35 },
        { icon: <IconAnimate/>, delay: 3.5, position: { top: '35%', right: '12%' }, yRange: 45 },
    ];

    return (
        <div className="animated-step-container">
            {/* Floating Background Icons */}
            <div className="floating-icons-wrapper">
                {floatingIcons.map((item, index) => (
                    <motion.div
                        key={index}
                        className="floating-icon"
                        style={{...item.position , zIndex: 0}}
                        initial={{ 
                            opacity: 0.4,
                            y: 0,
                            scale: 0.8
                        }}
                        animate={{
                            opacity: [0.3, 0.6, 0.4, 0.5, 0.3],
                            y: [0, -item.yRange, 0, item.yRange, 0],
                            scale: [0.8, 1, 0.9, 1, 0.8],
                            rotate: [0, 5, 0, -5, 0]
                        }}
                        transition={{
                            duration: 8 + (index * 0.5), // Different duration for each icon
                            repeat: Infinity,
                            delay: item.delay,
                            ease: "easeInOut"
                        }}
                    >
                        {item.icon}
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default AnimatedStepIndicator;